<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลหน่วยตรวจสอบย่อย' : 'เพิ่มข้อมูลหน่วยตรวจสอบย่อย' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="subCbForm">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="departmentId" class="form-label mb-0 required">หน่วยงาน</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="departmentId" formControlName="departmentId">
          <option [ngValue]="null">-- เลือกหน่วยงาน --</option>
          @for (d of departments; track d.id) {
            <option [ngValue]="d.id">{{ d.nameTh }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="title" class="form-label mb-0 required">ชื่อหน่วยตรวจสอบย่อย</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="title" formControlName="title"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="taxid" class="form-label mb-0">เลขประจำตัวผู้เสียภาษี</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="taxid" formControlName="taxid" maxlength="13"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="refId" class="form-label mb-0">รหัสอ้างอิง</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="refId" formControlName="refId"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="address" class="form-label mb-0">ที่อยู่</label></div>
      <div class="col-sm-8"><textarea class="form-control form-control-sm" id="address" formControlName="address" rows="3"></textarea></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="zipcode" class="form-label mb-0">รหัสไปรษณีย์</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="zipcode" formControlName="zipcode" maxlength="5"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="telephone" class="form-label mb-0">โทรศัพท์</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="telephone" formControlName="telephone"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="fax" class="form-label mb-0">โทรสาร</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="fax" formControlName="fax"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="lat" class="form-label mb-0">ละติจูด</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="lat" formControlName="lat"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="lng" class="form-label mb-0">ลองจิจูด</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="lng" formControlName="lng"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="state" formControlName="state">
          <option [ngValue]="1">เผยแพร่</option>
          <option [ngValue]="0">ไม่เผยแพร่</option>
        </select>
      </div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">วันที่สร้าง</label></div>
        <div class="col-sm-8"><input class="form-control form-control-sm" [value]="subcb?.createdDate | date:'dd/MM/yyyy HH:mm'" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">วันที่แก้ไข</label></div>
        <div class="col-sm-8"><input class="form-control form-control-sm" [value]="subcb?.modifiedDate | date:'dd/MM/yyyy HH:mm'" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
